export const ActiveStatus = 1;
export const FreeStatus = 5;
export const CancelledStatus = 3;
export const DeclinedCardStatus = 4;
export const PausedMember = 6;
export const DeclinedRenewalStatus = 7;

export function getPausedUrl(status: number) {
  return "/menu/renewBill.do?tb=PAUSED_MEMBER";
}

export function getRenewUrl(status: number) {
  const url = "/menu/renewBill.do?tb=";

  let tb = "";
  if (status === CancelledStatus) {
    tb = 'CANCELLED_MEMBER';
  } else if (status === DeclinedCardStatus) {
    tb = 'DECLINED_CREDIT_CARD';
  } else if (status === DeclinedCardStatus) {
    tb = 'PAUSED_MEMBER';
  } else if (status === DeclinedRenewalStatus) {
    tb = 'DECLINED_RENEWAL';
  }

  return url + tb;
}

